import { Row, Col, Card } from 'antd';
import { ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';

const { IconPopover } = ssCommonUtils;

export default class DodStepperHeader extends React.Component {
    constructor(props) { super(props); }
    render() {
        const { text } = this.props;
        let dodEmail, dodPhone;
        if(text['CINFO']) {
            dodEmail = (
                <span style={{ fontWeight: 'bold' }}>
                    {text['CINFO'].c[0].text}
                </span>
            );
            dodPhone = (
                <span style={{ fontWeight: 'bold' }}>
                    {text['CINFO'].c[1].text}
                </span>
            );
        }

        return (
            <div>
                <Row type='flex' justify='space-around' align='middle' style={{ margin: '15px 0 15px 0' }}>
                    <Col span={23} style={{ fontWeight: 'bold', fontSize: '24px' }}>
                        <Card bodyStyle={{ padding: '10px', textAlign: 'center' }}>
                            {'FTSP '}
                            <span style={{ color: 'rgb(53, 158, 255)' }}>
                                {'U.S. DoD Attaché'}
                            </span>
                            {' Registration'}
                            <Row>
                                <Col>
                                    {dodEmail == null || dodPhone == null ? null : (
                                        <IconPopover title='Help' header='Need help?' placement='bottom'>
                                            <div>
                                                {'Please Contact the FTSP Help Desk at '}
                                                {dodEmail}
                                                {' or '}
                                                {dodPhone}
                                                {'.'}
                                            </div>
                                        </IconPopover>
                                    )}
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }
}
